
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/pomoc",
      function () {
        return require("private-next-pages/moje-konto/pomoc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/pomoc"])
      });
    }
  